import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

import { TrackingEvents, TrackingPayload } from '../core.types';

export enum QuickFilterName {
    Category = 'Category',
    Creator = 'Creator',
    ExcludeAuctionHouses = 'Exclude Auction Houses',
    Location = 'Item Location',
    MaterialsAndTechniques = 'Material / Technique',
    ShippingAndDelivery = 'Shipping & Delivery',
    StylePeriod = 'Style / Period',
    Subject = 'Subject',
    TopRatedHouse = 'Top Rated House',
}

type QuickFilterPillClickedPayload = TrackingPayload & {
    quickFilterName: QuickFilterName;
};

export const trackQuickFilterPillClickedAnalytics = (payload: QuickFilterPillClickedPayload) => {
    track(TrackingEvents.SearchPage.QuickFilterPillClicked, payload);
};

export const useTrackQuickFilterPillClicked = () => {
    const { pathname, search } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        (quickFilterName: QuickFilterName) => {
            trackQuickFilterPillClickedAnalytics({
                pageName: getAmplitudePageNameFromPath(pathname, search),
                quickFilterName,
                url,
            });
        },
        [pathname, search, url]
    );
};
